'use client';

import { c as _c } from "react/compiler-runtime";
import { usePesquisaSatisfacao } from '../hooks/usePesquisaSatisfacao';
import { PesquisaSatisfacaoCard } from './PesquisaSatisfacaoCard';
interface PesquisaSatisfacaoToastProps {
  /** Sobe o cartão acima do lançador de chat, quando houver um no mesmo canto. */
  offsetInferiorPx?: number;
}

/**
 * Container do cartão. Monte-o UMA vez, no shell, e **não o monte** onde a pesquisa
 * não pode aparecer — montar e devolver `null` não serve: o hook roda os efeitos
 * assim mesmo e a pesquisa é consumida sem ninguém ver nada (review do PR #955,
 * COR-01). O `LayoutWrapper` é quem faz esse recorte.
 */
export function PesquisaSatisfacaoToast(t0) {
  const $ = _c(18);
  const {
    offsetInferiorPx: t1
  } = t0;
  const offsetInferiorPx = t1 === undefined ? 24 : t1;
  const {
    momento,
    estado,
    nota,
    comentario,
    enviandoComentario,
    progressoPercentual,
    selecionarNota,
    alterarComentario,
    submeterComentario,
    fechar,
    pausar,
    retomar
  } = usePesquisaSatisfacao();
  if (!momento) {
    return null;
  }
  const t2 = `${offsetInferiorPx}px`;
  let t3;
  if ($[0] !== t2) {
    t3 = {
      bottom: t2
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== alterarComentario || $[3] !== comentario || $[4] !== enviandoComentario || $[5] !== estado || $[6] !== fechar || $[7] !== momento || $[8] !== nota || $[9] !== pausar || $[10] !== progressoPercentual || $[11] !== retomar || $[12] !== selecionarNota || $[13] !== submeterComentario) {
    t4 = <PesquisaSatisfacaoCard momento={momento} estado={estado} nota={nota} comentario={comentario} progressoPercentual={progressoPercentual} enviandoComentario={enviandoComentario} onSelecionarNota={selecionarNota} onAlterarComentario={alterarComentario} onEnviarComentario={submeterComentario} onFechar={fechar} onPausarTimer={pausar} onRetomarTimer={retomar} />;
    $[2] = alterarComentario;
    $[3] = comentario;
    $[4] = enviandoComentario;
    $[5] = estado;
    $[6] = fechar;
    $[7] = momento;
    $[8] = nota;
    $[9] = pausar;
    $[10] = progressoPercentual;
    $[11] = retomar;
    $[12] = selecionarNota;
    $[13] = submeterComentario;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t3 || $[16] !== t4) {
    t5 = <div className="fixed right-6 z-50 flex flex-col items-end gap-3" style={t3}>{t4}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}